import type { AuthProvider, AuthActionResponse } from "@refinedev/core";
import { dataProvider } from "./dataProvider";
import { apiUrl } from "./consts";
import { notification } from "antd";
import { parseJwt } from "./utils/parseJwt";
// import { generateStreamToken } from "./utils/generateStreamToken";

export const TOKEN_KEY = "refine-auth";
export const GET_STREAM_TOKEN_KEY = "get-stream-auth";



interface ICustomAuthProviderInterface extends AuthProvider {
  acceptInvite: ((params: any) => Promise<AuthActionResponse>) | undefined;
}

export const authProvider: ICustomAuthProviderInterface = {
  login: async ({ email, password, remember }) => {
    try {
      const { data } = await dataProvider(apiUrl).custom({
        url: apiUrl + "/auth/login",
        method: "post",
        payload: {
          email,
          password,
          remember,
        },
      });
      const token = data.data.accessToken;
      localStorage.setItem(TOKEN_KEY, token);

      // const tokenResponse = await generateStreamToken(apiUrl);

      // localStorage.setItem(GET_STREAM_TOKEN_KEY, tokenResponse.token);

      return {
        success: true,
        redirectTo: "/",
      };
    } catch (error: any) {
      console.log("====================================");
      console.log(error);
      return {
        success: false,
        error: {
          name: "LoginError",
          message: error?.response?.data?.error,
        },
      };
    }
  },
  logout: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const { data } = await dataProvider(apiUrl).custom({
      url: apiUrl + "/auth/logout",
      method: "get",
      headers: { Authorization: `Bearer ${token}` },
    });
    localStorage.removeItem(TOKEN_KEY);

    return {
      success: true,
      redirectTo: "/login",
    };
  },
  check: async () => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      // const { data } = await dataProvider(apiUrl).custom({
      //   url: apiUrl + "/auth/me",
      //   method: "get",
      //   headers: { Authorization: `Bearer ${token}` },
      // });
      if (token) {
        return {
          authenticated: true,
        };
      }
    } catch (error: any) {
      return {
        authenticated: false,
        redirectTo: "/login",
      };
    }

    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);

      const { data } = await dataProvider(apiUrl).custom({
        url: apiUrl + "/auth/me",
        method: "get",
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("=========data=========", data);

      if (token && data) {
        return {
          name: data?.data?.fullName,
          email: data?.data?.email,
          profilePictureURL: data?.data?.profilePictureURL,
          id: data?.data?.id,
          role: data?.data?.role,
          authenticated: true,
        };
      }
    } catch (error: any) {
      localStorage.removeItem(TOKEN_KEY);

      return {
        authenticated: false,
        redirectTo: "/login",
      };
    }

    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },
  forgotPassword: async ({ email }) => {
    try {
      const { data } = await dataProvider(apiUrl).custom({
        url: apiUrl + "/auth/forgot_password",
        method: "post",
        payload: {
          email,
        }
      });

      console.log("Email reset successfully!")

      // Displaying success notification directly from here
      notification.success({
        message: "Success",
        description: "Reset password link sent. Please check your email!",
        duration: 3, // Notification duration in seconds
      });
      return {
        success: true,
      }
    } catch (error: any) {
      console.log("_____________---_____________");
      console.log(error);
      // Displaying failure notification directly from here
      notification.error({
        message: "Error",
        description: error.response?.data?.error || "An unexpected error occurred.",
        duration: 3,
      });
      return {
        success: false,
        error: {
          name: "ForgotPasswordError",
          message: error.response.data.error || "Something went wrong!",
        },
      };
    }
  },
  updatePassword: async ({ token, password }) => {
    try {
      await dataProvider(apiUrl).custom({
        url: apiUrl + "/auth/reset_password",
        method: "patch",
        payload: {
          token,
          newPassword: password,
        }
      });

      console.log("Password reset successfully!")
      return {
        success: true,
        message: "Password reset succssfully. Please login",
        redirectTo: "/login",
      }
    } catch (error: any) {
      console.log("___________UPDATE-PASSWORD______________");
      console.log(error);
      return {
        success: false,
        error: {
          name: "ResetPasswordError",
          message: error.response.data?.error,
        },
      };
    }
  },
  acceptInvite: async ({ token, newPassword }) => {
    try {
      await dataProvider(apiUrl).custom({
        url: apiUrl + "/auth/accept_invite",
        method: "patch",
        payload: {
          token,
          newPassword
        }
      });

      console.log("Invite accepted successfully!")
      return {
        success: true,
        redirectTo: "/login",
        message: "Invite accepted succssfully. Please login",
      }
    } catch (error: any) {
      console.log("___________ACCEPT-INVITE______________");
      console.log(error);
      return {
        success: false,
        error: {
          name: "AcceptInviteError",
          message: error.response.data?.error,
        },
      };
    }
  },
  onError: async (error) => {
    console.log("====================================");
    console.error(error);
    // if (error.status === 401 || error.status === 403) {
    //   return {
    //     logout: true,
    //     redirectTo: "/login",
    //     error,
    //   };
    // }
    return { error };
  },
};
